export default __webpack_public_path__ + "static/lifeInsurance-4d15bf847234e79192627974ff8077b1.png";